<template>
  <v-list
    two-line
    class="pt-0"
  >
    <v-list-item-group
      v-model="selected"
      @change="selectedChange"
    >
      <template v-for="(ti, i) in tabItems">
        <v-list-item
          :key="ti.id"
          class="py-0"
          :value="ti.id"
          style="height: 50px"
        >
          <template #default>
            <v-list-item-content class="py-0 h-100">
              <v-row class="py-0">
                <v-col
                  cols="3"
                  class="py-0 d-flex justify-center align-center"
                >
                  <span class="text-subtitle-1">{{ ti.no }}</span>
                </v-col>
                <v-col
                  cols="4"
                  class="pa-0 d-flex justify-center align-center"
                >
                  <floorplan-table-preview
                    style="height: 100%"
                    :seats="ti.seats"
                    :shape="ti.shape"
                  />
                </v-col>
                <v-col
                  cols="4"
                  class="py-0 d-flex justify-center align-center"
                >
                  {{ $t('label.x_seats', [ti.seats]) }}
                </v-col>
              </v-row>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                v-if="ti.posX === undefined || ti.posY === undefined"
                small
                icon
                @click="placeTabItem(i, ti)"
              >
                <v-icon>
                  mdi-plus-circle-outline
                </v-icon>
              </v-btn>
              <v-icon
                v-else
                style="width: 28px; height: 28px"
              >
                mdi-check
              </v-icon>
            </v-list-item-action>
          </template>
        </v-list-item>

        <v-divider
          v-if="i < tabItems.length - 1"
          :key="`divider_${i}`"
        />
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import TabItem from '@/model/TabItem';
import FloorplanTablePreview from '@/components/views/floorplan/FloorplanTablePreview.vue';

export default Vue.extend({
  name: 'FloorplanEditSidebar',
  components: {
    FloorplanTablePreview,
  },
  props: {
    tabItems: { type: Object as PropType<Array<TabItem>>, required: true },
    selectedTabItemIds: { type: Object as PropType<Array<number>>, required: false, default: undefined },
  },
  data() {
    return {
      selected: undefined as number | undefined,
    };
  },
  watch: {
    selectedTabItemIds() {
      [this.selected] = this.selectedTabItemIds;
    },
  },
  methods: {
    selectedChange(tabItemId: number) {
      if (this.selected === undefined) { return; }
      this.$emit('selected', tabItemId);
    },
    placeTabItem(i: number, t: TabItem) {
      this.$emit('place-tabitem', i, t);
    },
  },
});
</script>
